import React from "react";
import { Link } from "react-router-dom";
const TopNav = () => {
  return (
    <div>
      <nav
        className="autohide navbar navbar-expand-lg navbar-light bg-primary topNav py-1 px-4"
        id="navbar"
      >
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img className="logo" src="/images/svg/websiteLogo.svg" alt="" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#main_nav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="main_nav">
            <ul className="navbar-nav ms-5 text-black">
              <li className="nav-item">
                <Link
                  to="/"
                  className="nav-link text-dark nav-link-grow-up"
                  href="#"
                >
                  {" "}
                  صفحه اصلی{" "}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/Products/Index"
                  className="nav-link text-dark nav-link-grow-up"
                  href="#"
                >
                  {" "}
                  محصولات{" "}
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link text-dark nav-link-grow-up" href="#">
                  {" "}
                  درباره ما{" "}
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-dark nav-link-grow-up" href="#">
                  {" "}
                  تماس با ما{" "}
                </a>
              </li>
            </ul>

            {/* <div className="ms-auto me-3 text-dark">
              <span>
                <a href="">En</a>
              </span>
              <span className="mx-2">/</span>
              <span>چهارشنبه 27 اسفند</span>
            </div> */}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default TopNav;
